const accordionsHolders = document.querySelectorAll(".lp-js-accordions");

if (accordionsHolders && !!accordionsHolders.length) {
  accordionsHolders.forEach((holder) => {
    const accordions = holder.querySelectorAll(".lp-accordion");

    accordions.forEach((accordion, index) => {
      const accordionBtn = accordion.querySelector(".lp-accordion__header");
      const panel = accordion.querySelector(".lp-accordion__panel");

      if (index === 0) {
        accordion.classList.add("show-text");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }

      accordionBtn.addEventListener("click", () => {
        // zatvori sve accordeone
        accordions.forEach((acc) => {
          const accPanel = acc.querySelector(".lp-accordion__panel");
          acc.classList.remove("show-text");
          accPanel.style.maxHeight = null;
        });

        // otvori trenutni accordion ako već nije otvoren
        if (!accordion.classList.contains("show-text")) {
          accordion.classList.add("show-text");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  });
}
